<script setup lang="ts">
import { Loader } from "@googlemaps/js-api-loader"
import { uniqueId } from "lodash-es"
import ComboBoxV2 from "./ComboBoxV2.vue"
import { GooglePlacesSource } from "./sources"
import { type ComboBoxStore, useComboBoxStore } from "./store"

const props = defineProps<{
  name: string
  locations: string[]
}>()

const store: ComboBoxStore = useComboBoxStore(uniqueId("locationStore"))
const { source, selections } = storeToRefs(store)

const googleLoader = new Loader({
  apiKey: "AIzaSyDm79yOVgpH3Gscx0s95wZ5P5s2SAz25Kc",
  version: "beta",
  libraries: ["places"],
})

void googleLoader.importLibrary("places").then(({ AutocompleteSuggestion }) => {
  source.value = new GooglePlacesSource(AutocompleteSuggestion)
})

selections.value = props.locations.map((location) => {
  return { id: location, value: location, text1: location }
})
</script>

<template>
  <ComboBoxV2 :name="name" :store="store" :readonly="true" placeholder="Search locations" />
</template>
